<template>
	<div class="imc_err">
		<b-alert :show="dismissCountDown" dismissible variant="danger"
				 @dismissed="dismissCountDown=0"
				 @dismiss-count-down="countDownChanged"
		>
			<p>{{string_err}}</p>

			<b-progress
				variant="warning"
				:max="dismissSecs"
				:value="dismissCountDown"
				height="4px"
			></b-progress>
		</b-alert>
	</div>

</template>

<script>


export default {
	name: "err",

	data() {
		return {
			string_err : "",
			dismissCountDown : 0,
			dismissSecs: 10,
		}
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown
		},
	},

	created () {

		EventBus.$on('show_err', e => {
			if(e != undefined) {
				this.dismissCountDown = e.time;
				this.string_err       = e.err;
			}
		});
	}

}
</script>

<style scoped>

</style>
